import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Cloud } from 'lucide-react';
import { SiteSection, SiteSectionHeader } from '../../../../components/site';
import { platformNavIcons, platformNavItems } from '../../../../config/platformNav';

export const PlatformExploreModules: React.FC = () => (
  <SiteSection tone="muted" className="platform-explore-modules platform-explore-modules--premium">
    <SiteSectionHeader
      title="Explore platform modules"
      subtitle="Dive deeper into each layer of the stack"
      align="center"
    />
    <div className="platform-explore-grid">
      {platformNavItems.map((item) => {
        const Icon = platformNavIcons[item.to] ?? Cloud;
        return (
          <Link key={item.to} to={item.to} className="platform-explore-card">
            <span className="platform-explore-card__icon" aria-hidden>
              <Icon className="platform-explore-card__icon-svg" strokeWidth={1.75} />
            </span>
            <div className="platform-explore-card__body">
              <h3 className="platform-explore-card__title">{item.label}</h3>
              <p className="platform-explore-card__desc">{item.description}</p>
            </div>
            <span className="platform-explore-card__link">
              Learn more
              <ArrowRight className="platform-explore-card__arrow" aria-hidden />
            </span>
          </Link>
        );
      })}
    </div>
  </SiteSection>
);
